import { ApplicationStatuses } from '../enums/ApplicationStatuses'
import { UserRoles } from '../enums/UserRoles'

export default {
  methods: {
    canAcceptForApproval (user, application) {
      if (!user) {
        return false
      }

      return application.status === ApplicationStatuses.SUBDIVISION_YES &&
        [UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER].includes(user.role)
    },

    canState (user, application) {
      if (!user) {
        return false
      }

      let terminalRegion = null

      for (const key in this.terminalRegions) {
        if (this.terminalRegions[key].id === application.terminal_region_id && ['management_building', 'onega'].includes(this.terminalRegions[key].alias)) {
          terminalRegion = key
        }
      }

      const isAvailableTerminalRegion = application.status === ApplicationStatuses.SB_BEGIN && terminalRegion === null

      const isAvailableUserRoles = application.status === ApplicationStatuses.SB_BEGIN &&
        [UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER].includes(user.role)

      return isAvailableUserRoles && isAvailableTerminalRegion
    },

    canStateApprove (user, application) {
      if (!user) {
        return false
      }
      let terminalRegion = null

      for (const key in this.terminalRegions) {
        if (this.terminalRegions[key].id === application.terminal_region_id && ['management_building', 'onega'].includes(this.terminalRegions[key].alias)) {
          terminalRegion = key
        }
      }

      const isAvailableUserRoles = application.status === ApplicationStatuses.FSB_YES &&
        [UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER].includes(user.role)

      const isAvailableTerminalRegion = application.status === ApplicationStatuses.SB_BEGIN && terminalRegion !== null

      return isAvailableUserRoles || isAvailableTerminalRegion
    },

    canApprove (user, application) {
      if (!user) {
        return false
      }

      return ([ApplicationStatuses.BEGIN, ApplicationStatuses.AGENT_YES].includes(application.status) &&
        [UserRoles.SUBDIVISION].includes(user.role)) ||
      ([ApplicationStatuses.BEGIN].includes(application.status) &&
        [UserRoles.AGENT].includes(user.role) &&
        Number(this.form.application.agent_organization_id) === Number(user.organization_id)) ||
        (
          application.subdivision_id &&
          application.status === ApplicationStatuses.BEGIN &&
          [UserRoles.SB, UserRoles.SB_OTHER, UserRoles.SB_TRUCK].includes(user.role) &&
          user.subdivisions.length > 0 && user.subdivisions.includes(String(application.subdivision_id))
        )
    },

    canReject (user, application) {
      if (!user) {
        return false
      }

      return ([ApplicationStatuses.SB_BEGIN, ApplicationStatuses.SUBDIVISION_YES].includes(application.status) &&
        [UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER].includes(user.role)) ||
      ([ApplicationStatuses.BEGIN, ApplicationStatuses.AGENT_YES].includes(application.status) &&
        [UserRoles.SUBDIVISION].includes(user.role)) ||
      (application.status === ApplicationStatuses.BEGIN &&
        [UserRoles.AGENT].includes(user.role) &&
        Number(application.agent_organization_id) === Number(user.organization_id)) ||
      (
        application.subdivision_id &&
        application.status === ApplicationStatuses.BEGIN &&
        [UserRoles.SB, UserRoles.SB_OTHER, UserRoles.SB_TRUCK].includes(user.role) &&
        user.subdivisions.length > 0 && user.subdivisions.includes(String(application.subdivision_id))
      )
    }
  }
}
